import React from "react";
import useMetaTags from "../../hooks/useMetaTags"; // Adjust path based on your project structure

const ExerciseSportsDuringPeriodOrganic = () => {
  useMetaTags({
    title: "Staying Active During Periods: Why Organic Pads Are Better for Exercise",
    description: "Discover why organic pads are the best choice for staying comfortable and protected during exercise and sports while on your period.",
    keywords: "exercise during periods, organic sanitary pads, best pads for sports, period protection for workouts, breathable menstrual pads",
    author: "Organic Pads",
    robots: "index, follow",
    canonical: "/exercise-sports-during-period-organic",
    ogTitle: "Staying Active During Periods: Why Organic Pads Are Better for Exercise",
    ogDescription: "Maintain an active lifestyle during your period with breathable and comfortable organic pads designed for workouts and sports.",
    ogImage: "https://images.pexels.com/photos/4498151/pexels-photo-4498151.jpeg",
    ogUrl: "https://organicpads.shop/exercise-sports-during-period-organic",
    ogType: "article",
    twitterCard: "summary_large_image",
    twitterTitle: "Stay Active on Your Period: Why Organic Pads Are the Best for Exercise",
    twitterDescription: "Organic pads provide breathable, secure protection for workouts and sports. Stay comfortable and active during your period.",
    twitterImage: "https://images.pexels.com/photos/4498151/pexels-photo-4498151.jpeg",
    twitterSite: "@OrganicPads",
    twitterCreator: "@OrganicPads",
  });
  
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "/exercise-sports-during-period-organic"
    },
    "headline": "Staying Active During Periods: Why Organic Pads Are Better for Exercise",
    "description": "Discover why organic pads are the best choice for staying comfortable and protected during exercise and sports while on your period.",
    "image": "https://images.pexels.com/photos/4498151/pexels-photo-4498151.jpeg",
    "author": {
      "@type": "Organization",
      "name": "Organic Pads",
      "url": "/"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Organic Pads",
      "logo": {
        "@type": "ImageObject",
        "url": "/logo.png"
      }
    },
    "datePublished": "2025-02-24",
    "dateModified": "2025-02-24",
    "keywords": [
      "exercise during periods",
      "organic sanitary pads",
      "best pads for sports",
      "period protection for workouts",
      "breathable menstrual pads"
    ]
  }
  

  return (
    <>
    <div className="max-w-3xl mx-auto px-4 mt-20 py-8">
      <h1 className="text-3xl font-bold mb-6">
        Staying Active During Periods: Why Organic Pads Are Better for Exercise
      </h1>

      <img
        src="https://images.pexels.com/photos/4498151/pexels-photo-4498151.jpeg?w=600"
        alt="Exercise and Periods"
        className="w-full h-auto rounded-lg mb-6"
      />

      <p className="mb-4">
        Maintaining an active lifestyle during menstruation requires the right
        protection. Organic pads offer superior breathability and comfort during
        physical activity, making them ideal for exercise and sports.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        Exercise Benefits with Organic Pads
      </h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Better moisture management</li>
        <li>Reduced chafing risk</li>
        <li>Enhanced breathability</li>
        <li>Secure protection</li>
        <li>Comfortable movement</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-4">How to Stay Active?</h2>
      <p className="mb-4">
        Choose <strong>sports-friendly</strong> organic pads designed for
        movement and activity. Regular exercise can help reduce period
        discomfort.
      </p>

      <img
        src="https://plus.unsplash.com/premium-photo-1702598576513-fe7425ebf6bd?w=600"
        alt="Active Care"
        className="w-full h-auto rounded-lg mb-6"
      />

      <h2 className="text-2xl font-semibold mt-6 mb-4">Final Thoughts</h2>
      <p className="mb-4">
        Don't let your period stop you.{" "}
        <strong>Stay active with organic protection!</strong>
      </p>
    </div>
     {/* Schema Markup */}
     <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
    </>
  );
};

export default ExerciseSportsDuringPeriodOrganic;
